import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { HttpErrorResponse } from '@angular/common/http';

import {
  AvatarComponent,
  ColorModeService,
  ContainerComponent,
  DropdownComponent,
  DropdownItemDirective,
  DropdownMenuDirective,
  DropdownToggleDirective,
  HeaderComponent,
  HeaderNavComponent,
  HeaderTogglerDirective,
  SidebarToggleDirective,
  TextColorDirective,
} from '@coreui/angular';

import { IconDirective } from '@coreui/icons-angular';
import { AuthService } from '../../../services/auth';
import { ErrorAdvicerService } from '../../../services/errorAdvicer.service';
import { AlertsPanelComponent } from '../../../components/alerts-panel/alerts-panel.component';
import { RoleId } from '../../../core/models/role.model';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  standalone: true,
  imports: [
    ContainerComponent,
    HeaderTogglerDirective,
    SidebarToggleDirective,
    IconDirective,
    HeaderNavComponent,
    NgTemplateOutlet,
    DropdownComponent,
    DropdownToggleDirective,
    TextColorDirective,
    AvatarComponent,
    DropdownMenuDirective,
    DropdownItemDirective,
    AlertsPanelComponent,
  ]
})
export class AdminHeaderComponent extends HeaderComponent {

  _authService     = inject(AuthService);
  _errorAdvService = inject(ErrorAdvicerService);
  readonly #colorModeService = inject(ColorModeService);
  readonly colorMode = this.#colorModeService.colorMode;

  readonly colorModes = [
    { name: 'light', text: 'Claro',      icon: 'cilSun'      },
    { name: 'dark',  text: 'Oscuro',     icon: 'cilMoon'     },
    { name: 'auto',  text: 'Automático', icon: 'cilContrast' },
  ];

  readonly icons = computed(() => {
    const m = this.colorMode();
    return this.colorModes.find(x => x.name === m)?.icon ?? 'cilSun';
  });

  readonly userData = toSignal(this._authService.userData$, {
    initialValue: this._authService.userDataValue,
  });

  readonly fullName = computed(() => {
    this.userData();
    const raw = localStorage.getItem('SHAREWAVE_USERDATA');
    if (!raw) return '';
    try { const u = JSON.parse(raw); return `${u.first_name} ${u.last_name}`.trim(); }
    catch { return ''; }
  });

  readonly userRole = computed(() => {
    this.userData();
    const raw = localStorage.getItem('SHAREWAVE_USERDATA');
    if (!raw) return '';
    try { const u = JSON.parse(raw); return u?.role ?? ''; }
    catch { return ''; }
  });

  readonly isGestorOrEditor = this._authService.hasRoleId(RoleId.GESTOR) ||
                               this._authService.hasRoleId(RoleId.EDITOR);

  sidebarId = input('sidebar1');

  constructor() { super(); }

  onLogout(): void {
    this._authService.onLogout().subscribe({
      error: (err: HttpErrorResponse) => {
        if (err.status !== 401) this._errorAdvService.setErrorMessage(err.message);
      }
    });
  }
}
